import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, Tooltip} from "reactstrap";
import TextareaAutosize from "react-textarea-autosize";
import AnswerContainer from "./answerContainer";
import {injectIntl} from "react-intl";

function ResizableTextarea(props) {
	const {answer, onChange, classes, isError, resize, rows, value, intl} = props

	const [touched, setTouched] = React.useState(value ? true : false);
	const isValid = () => {
		return touched && !isError && value;
	}

	const getComponent = () => {
		if (resize) {
			return <TextareaAutosize
				class={classnames({
					'valid': isValid(),
					'autosize': true,
					'resize-none': !resize,
					'error': isError
				}) + " " + classes}
				minRows={4}
				type={'text'}
				onBlur={() => {
					if (value) {
						setTouched(true)
					}
				}}
				onChange={onChange}
				value={value}
				placeholder={intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
			/>
		} else {
			return <input
				class={classnames({
					'valid': isValid(),
					'autosize': true,
					'error': isError
				}) + " " + classes}
				type={'text'}
				onBlur={() => {
					if (value) {
						setTouched(true)
					}
				}}
				onChange={onChange}
				value={value}
				placeholder={intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
			/>
		}
	}

	return (
		<AnswerContainer answer={answer} classes={"textarea-resize-container p-0"} component={
			<React.Fragment>
				{getComponent()}
			</React.Fragment>
		} />
	);
}

ResizableTextarea.propTypes = {
	answer: PropTypes.string,
	onChange: PropTypes.func,
	classes: PropTypes.any,
	isError: PropTypes.any,
	resize: PropTypes.any,
	rows: PropTypes.any,
	value: PropTypes.bool
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(injectIntl(ResizableTextarea));